export default __webpack_public_path__ + "static/media/2.fdc00149.webp";